import React, { PropsWithChildren, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { reorderData as reorderDataLoadingSelector } from '@epi-selectors/loading';
import { isError as isErrorSelector } from '@epi-selectors/voucherReorder';
import * as voucherReorderActions from '@epi-actions/voucherReorder';
import { useGetMetadataQuery } from '@epi-api/companyMetadata';
import { goToPage } from '@epi-actions/navigation';
import { routerPaths } from '@epi-constants/routerPaths';

import { LoadingData } from 'src/scripts/routes/LoadingData';

import { OrderAmount } from './OrderAmount';

export const OrderAmountLoadingData = (props: PropsWithChildren<any>) => {
  const { orderId } = useParams<{ orderId: string }>();
  const dispatch = useDispatch();
  const { data: companyMetadata, isSuccess } = useGetMetadataQuery();

  useEffect(() => {
    if (isSuccess && !companyMetadata?.orderVouchersEnabled) {
      dispatch(goToPage(routerPaths.home));
    }
  }, [isSuccess, companyMetadata]);

  return (
    <LoadingData
      {...props}
      loadAction={() => voucherReorderActions.loadReorderData(orderId)}
      loadingSelector={state => reorderDataLoadingSelector(state, orderId)}
      errorSelector={state => isErrorSelector(state)}
    >
      <OrderAmount />
    </LoadingData>
  );
};
